export enum IcoPaymentMethod {
	CC,
	BTC,
	ETH,
}

export enum PaymentMethod {
	CC,
}
